import React, { useState } from 'react';
import { submitFormToGoogleSheet } from '../services/formService';

const EMPTY_FORM = {
  name: '',
  email: '',
  linkedin: '',
  company: '',
  title: '',
  size: '',
  phone: '',
  address: '',
};

export const FormCard = () => {
  const [formData, setFormData] = useState(EMPTY_FORM);

  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { id, value } = e.target;
    const fieldName = id.replace('f-', '');
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
    if (errors[fieldName]) {
      setErrors(prev => ({
        ...prev,
        [fieldName]: false
      }));
    }
    // Hide the success banner once the user starts a new entry
    if (success) {
      setSuccess(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const fields = ['name', 'email', 'linkedin', 'company', 'title', 'size', 'phone', 'address'];
    
    fields.forEach(field => {
      if (!formData[field].trim()) {
        newErrors[field] = true;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      await submitFormToGoogleSheet(formData);
      setFormData(EMPTY_FORM); // reset the form
      setErrors({});
      setSuccess(true);
    } catch (error) {
      console.error('Form submission error:', error);
      alert('There was an error submitting your form. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-card" id="form-card">
      <div className="form-title">Claim your author copy</div>
      <div className="form-sub">For HR leaders at 1,000+ employee organisations in India. Applications reviewed within 48 hours.</div>

      {success && (
        <div className="form-success" role="status" aria-live="polite">
          <span className="form-success-icon">✓</span>
          <span>Submission successful — thank you! We'll be in touch within 48 hours.</span>
        </div>
      )}

      <form id="form-fields" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="f-name">Full Name</label>
            <input
              className="form-input"
              type="text"
              placeholder="As it appears on LinkedIn"
              id="f-name"
              autoComplete="name"
              value={formData.name}
              onChange={handleChange}
              style={{ borderColor: errors.name ? '#EE1B24' : '' }}
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="f-email">Work Email</label>
            <input
              className="form-input"
              type="email"
              placeholder="you@company.com"
              id="f-email"
              autoComplete="email"
              value={formData.email}
              onChange={handleChange}
              style={{ borderColor: errors.email ? '#EE1B24' : '' }}
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="f-linkedin">LinkedIn Profile URL</label>
            <input
              className="form-input"
              type="url"
              placeholder="https://linkedin.com/in/yourprofile"
              id="f-linkedin"
              value={formData.linkedin}
              onChange={handleChange}
              style={{ borderColor: errors.linkedin ? '#EE1B24' : '' }}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label" htmlFor="f-company">Company</label>
              <input
                className="form-input"
                type="text"
                placeholder="Organisation name"
                id="f-company"
                autoComplete="organization"
                value={formData.company}
                onChange={handleChange}
                style={{ borderColor: errors.company ? '#EE1B24' : '' }}
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="f-title">Job Title</label>
              <input
                className="form-input"
                type="text"
                placeholder="e.g. CHRO, VP HR"
                id="f-title"
                value={formData.title}
                onChange={handleChange}
                style={{ borderColor: errors.title ? '#EE1B24' : '' }}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label" htmlFor="f-size">Employee Count</label>
              <select
                className="form-input"
                id="f-size"
                value={formData.size}
                onChange={handleChange}
                style={{ borderColor: errors.size ? '#EE1B24' : '' }}
              >
                <option value="">Select range</option>
                <option>1,000 – 5,000</option>
                <option>5,001 – 10,000</option>
                <option>10,001 – 50,000</option>
                <option>50,001+</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="f-phone">Phone (for shipping)</label>
              <input
                className="form-input"
                type="tel"
                placeholder="+91 ..."
                id="f-phone"
                autoComplete="tel"
                value={formData.phone}
                onChange={handleChange}
                style={{ borderColor: errors.phone ? '#EE1B24' : '' }}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="f-address">Shipping Address</label>
            <input
              className="form-input"
              type="text"
              placeholder="Full postal address for delivery"
              id="f-address"
              autoComplete="street-address"
              value={formData.address}
              onChange={handleChange}
              style={{ borderColor: errors.address ? '#EE1B24' : '' }}
            />
          </div>

          <button className="submit-btn" type="submit" disabled={loading}>
            {loading ? 'Submitting...' : 'Request Your Copy →'}
          </button>
          <div className="form-note">Your information is used only for application review and delivery. No data sold or shared.</div>
        </form>
    </div>
  );
};
